// extracted by mini-css-extract-plugin
export default {"companyContainer":"RR-z","companyImage":"SR-z","container":"TR-z","heading":"UR-z","darkText":"VR-z","smallHeading":"WR-z","darkBackground":"XR-z","whiteBackground":"YR-z"};